<template>
  <div class="knowledgeList">
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
    </div>
    <div class="container">
      <div style="background: #fff;">
        <div class="nav">
          <div style="display: flex;align-items: center">
            <span style="color: #808080">当前位置：</span>
            <el-breadcrumb separator="/" style="font-size: 15px">
              <el-breadcrumb-item :to="{ path: '/knowledgeBase' }"><span>水泵知识库</span></el-breadcrumb-item>
              <el-breadcrumb-item><span>知识库列表</span></el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 搜索框 -->
          <div class="serviceSearch">
            <div class="greatField-con-search">
              <el-input
                placeholder="请输入关键字"
                v-model="keyValue"
                @keyup.native.enter="search()"
                ref="search"
                clearable
              >
                <template slot="append">
                  <div class="greatField-con-search-icon" @click="search()"></div>
                </template>
              </el-input>
            </div>
          </div>
        </div>
        <div class="news">
          <div class="news-left">
            <div
              class="type-item"
              v-for="(item,index) in typeList"
              :key="index"
              @click="typeClick(item,index)"
              :class="curIndex == index ? 'type-active' : ''"
            >{{ item.title }}</div>
          </div>
          <div class="news-right">
            <div class="noData" v-if="newsList.length == 0">暂无数据</div>
            <div
              class="news-item"
              v-for="(item,index) in newsList"
              :key="index"
              @click="clickNews(item)"
            >
              <div class="news-img" :style="{ backgroundImage: `url(${item.pictureUrl})` }"></div>
              <div class="news-con">
                <div class="news-title">{{item.title}}</div>
                <div class="news-time">
                  <i class="el-icon-time"></i>
                  {{item.createDate}}
                  <i
                    class="el-icon-reading"
                    style="margin-left: 10px;"
                  ></i>
                  {{ item.pageViews }}
                </div>
              </div>
            </div>
            <div v-if="newsList.length > 0" style="text-align: center;padding: 30px 0;">
              <el-pagination
                @current-change="onChangeCurrent"
                :current-page="params.current"
                :page-size="params.pageSize"
                background
                layout="prev, pager, next"
                :total="params.total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategory, getknowByUuid } from "@/utils/interface.js";
export default {
  data() {
    return {
      headerBgUrl: require("../../assets/knowledge.jpg"),
      curIndex: "",
      curUuid: "",
      keyValue: "",
      params: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      typeList: [
        // { title: "材料" },
        // { title: "设计" },
        // { title: "工艺" },
        // { title: "设备" },
        // { title: "应用" },
        // { title: "运维" }
      ],
      newsList: []
    };
  },
  mounted() {
    if (this.$route.query.uuid) {
      getCategory({
        current: 1,
        pageSize: 20
      }).then(res => {
        this.typeList = res[0].children;
        this.curUuid = this.$route.query.uuid;
        this.curIndex = this.typeList.findIndex(item => {
          return item.uuid == this.$route.query.uuid;
        });
        this.getNewsList(this.$route.query.uuid);
      });
    } else {
      this.getdataList();
    }
  },
  methods: {
    typeClick(item, index) {
      this.curIndex = index;
      this.curUuid = item.uuid;
      this.getNewsList(item.uuid);
    },
    /* 搜索关键字 */
    search() {
      this.params.current = 1;
      this.getNewsList(this.curUuid, this.keyValue);
    },
    /* 获取分类 */
    getdataList() {
      getCategory({
        current: 1,
        pageSize: 20
      }).then(res => {
        this.typeList = res[0].children;
        this.curUuid = res[0].children[0].uuid;
        this.getNewsList(res[0].children[0].uuid);
      });
    },
    /* 获取某一分类具体列表 */
    getNewsList(uuid, title) {
      getknowByUuid({
        current: this.params.current,
        pageSize: this.params.pageSize,
        programUuid: uuid || this.curUuid,
        title: title || this.keyValue
      }).then(res => {
        this.newsList = res.data;
        this.params.total = res.total;
      });
    },
    onChangeCurrent(e) {
      this.params.current = e;
      this.getdataList();
    },
    clickNews(item) {
      let router = this.$router.resolve({
        path: "./knowledgeDetail",
        query: {
          uuid: item.uuid
        }
      });
      window.open(router.href, "_blank");
    }
  }
};
</script>

<style scoped lang="less">
@basic-colors: #009999;
/* 搜索框样式 */
/deep/ .el-input-group--append .el-input__inner {
  height: 30px;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  border: none;
}

/* 搜索图标样式 */
/deep/ .el-input-group__append {
  padding: 0 12px;
  background-color: #fff;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  border: none;

  &:hover {
    cursor: pointer;
  }
}
/deep/ .el-input__suffix {
  right: 0px;
  top: -10%;
  // transform: translateY(-12px);
}
.knowledgeList {
  background-color: #ffffff;
  .noData {
    color: #888;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;
    .nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      /* 搜索框 */
      .serviceSearch {
        height: 50px;
        // background: url('../../assets/publicService/digitalize/26.png') no-repeat center center/100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .greatField-con-search {
          width: 200px;
          // box-shadow: 0 0 10px #9999998a;
          border: 1px solid #999;
          border-radius: 24px;

          .greatField-con-search-icon {
            width: 15px;
            height: 15px;
            background: url("../../assets/search.png") no-repeat center
              center/15px 16px;
          }
        }
      }
    }
    .news {
      width: 1200px;
      display: flex;
      flex-flow: row nowrap;
      margin-bottom: 20px;
      min-height: 300px;
      .news-left {
        width: 240px;
        border-left: 1px solid #efefef;
        .type-item {
          width: 236px;
          height: 40px;
          line-height: 40px;
          margin-top: 16px;
          cursor: pointer;
          text-align: center;
          &:hover {
            background: #009999b8;
            border-radius: 0px 20px 20px 0px;
          }
        }
        .type-active {
          color: #fff;
          background: #009999;
          border-radius: 0px 20px 20px 0px;
        }
      }
      .news-right {
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        margin-left: 40px;
        position: relative;
        .news-item {
          width: 100%;
          height: 145px;
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          margin: 20px 0;
          cursor: pointer;
          .news-img {
            width: 284px;
            height: 145px;
            margin-right: 40px;
            background-size: 100% 100%;
          }
          .news-con {
            flex: 1;
            height: 100%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: space-between;
            .news-title {
              font-size: 16px;
              font-weight: bold;
              color: #000000;
            }
            .news-time {
              font-size: 12px;
              color: #b1b1b1;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/knowledgeBase/knowledgeList.vue